// ummobile - index.js; centralized state management for the application.
import { getEmployeeList, getMaterialList, getEquipmentList } from '../services/requests'

let store = { 
  user: {
    username: '',
    key: ''
  },


  employees: [],
  materials: [],
  equipment: [],
  chargeTypes: [
    'Regular', 
    'Over Time',
    'Special'
  ],

  callbacks: {
    employeeReady: null,
    materialReady: null,
    equipmentReady: null
  }
}

export default store


// TODO: Setup configurations for development, test, production, etc.
store.getServerUrl = () => {
  // NO LONGER USED
  return '';
}

store.whenEmployeesReady = (callback) => {
  store.callbacks.employeeReady = callback

  if (store.employees.length > 0) {
    callback(store.employees)
  }
}

store.whenEquipmentReady = (callback) => {
  store.callbacks.equipmentReady = callback

  if (store.equipment.length > 0) {
    callback(store.equipment)
  }
}

store.whenMaterialsReady = (callback) => {
  store.callbacks.materialReady = callback
  if (store.materials.length > 0) {
    callback(store.materials)
  }
}

store.init = () => {
  getEmployeeList()
    .toArray((employees) => {
      store.employees = employees

      if (store.callbacks.employeeReady) {
        store.callbacks.employeeReady(store.employees)
      }
    })

  getMaterialList()
    .toArray((materials) => {
      store.materials = materials

      if (store.callbacks.materialReady) {
        store.callbacks.materialReady(store.materials)
      }
    })

  getEquipmentList()
    .toArray((equipment) => {
      store.equipment = equipment

      if (store.callbacks.equipmentReady) {
        store.callbacks.equipmentReady(store.equipment)
      }
      
    })
}


// WEBPACK FOOTER //
// ./src/store/index.js